//=====================================================
//　予約情報(明細)
//=====================================================
import { useContext } from "react";
import { BtnReservation } from "../common/BtnReservation";
import { BtnReservationChange } from "../common/BtnReservationChange";
import { BtnReservationCancel } from "../common/BtnReservationCancel";
import { IFDataReservationInfo } from "../utils/UseReservationInfo";
import { useHistory } from "react-router-dom";
import { ReservationType } from "../utils/ConstCommon";
import { CtxNewReservation, CtxClinicSystemInfo } from "../utils/Contexts";
import { formatString } from "../utils/CommonFunc";


interface IFProps {
    idx:number,
    card:IFDataReservationInfo
}

export function ReservationCard( props: IFProps ){
    const history = useHistory();
    const cnr = useContext(CtxNewReservation);
    const ccsi = useContext(CtxClinicSystemInfo);

    //再診ボタンクリック処理
    function clickReturn(reserve:IFDataReservationInfo){
        cnr.create(ReservationType.Return, {reserveId: reserve.reserveId, menu: reserve.medicalType, menutime: Number( reserve.time ), doctor: reserve.doctorName, beforeDate:reserve.datetime, medicalTypeId:reserve.medicalTypeId});
        history.push(`/reservation/date/monthly`);
    }
    
     //変更ボタンクリック処理
    function clickChange(reserve:IFDataReservationInfo){
        cnr.create(ReservationType.Change, {reserveId: reserve.reserveId, menu: reserve.medicalType, menutime: Number( reserve.time ), doctor: reserve.doctorName, beforeDate:reserve.datetime, medicalTypeId:reserve.medicalTypeId});
        history.push("/reservation/date/monthly");
    }

    //キャンセルボタンクリック処理
    function clickCancel(reserve:IFDataReservationInfo){
        cnr.create(ReservationType.Cancel, {date: formatString(reserve.datetime), menu: reserve.medicalType, menutime: Number( reserve.time ), doctor: reserve.doctorName, reserveId: reserve.reserveId});
        history.push("/mypage/cancel");
    }


    return (
        <>
            <div className="next-reservation-title"><span>{props.idx}</span></div>
            <div className="next-reservation-contents">
                <dl className="info_list info_list-reserve">
                    <dt>ご予約日時</dt>
                    {props.card.determination ? 
                        <>
                            <dd className="info_list-reserve-datetime">{props.card.datetime}～</dd>
                        </>
                        :
                        <>
                            <dd className="info_list-reserve-datetime undecided">未決定</dd>
                        </>
                    }
                    { props.card.medicalType && ccsi.data.display.medicalType && 
                        <>
                            <dt>治療メニュー</dt>
                            <dd className="info_list-reserve-menu">
                                {props.card.medicalType}
                                {ccsi.data.display.medicalCareTime && Number(props.card.time) > 0 && 
                                    <p className="treatment_time text-s">診療時間：{props.card.time}分</p>
                                }
                            </dd>
                        </>
                    }
                    { props.card.doctorName && ccsi.data.display.doctor && 
                            <>
                                <dt>担当医</dt>
                                <dd className="info_list-reserve-doctor">{props.card.doctorName}</dd>
                            </>
                    }
                </dl>
                <div className="next-reservation-contents-btn">
                { ( !props.card.determination && ccsi.data.usability.appointment.add ) && 
                        <BtnReservation enable={props.card.operation.add} onClick={function(){clickReturn(props.card)}}/>
                }
                { ( props.card.determination && ccsi.data.usability.appointment.update ) &&  
                    <BtnReservationChange enable={props.card.operation.update} onClick={function(){clickChange(props.card)}}/> 
                }
                { ( props.card.determination && ccsi.data.usability.appointment.delete ) &&  
                    <BtnReservationCancel enable={props.card.operation.delete} onClick={function(){clickCancel(props.card)}}/>
                }
                </div>
            </div>
        </>
    )
}